import React from 'react';
import styles from './TechSpecComponent.module.css';
import { Container, CustomImage as Image } from '..';

const Title = ({ children }: { children: React.ReactNode }) => (
  <h1 className={styles.title}>{children}</h1>
);

// Product image
const ProductImage = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.productImage}>{children}</div>
);

// Specifications section
const SpecificationSection = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.specificationSection}>{children}</div>
);

const SectionTitle = ({ children }: { children: React.ReactNode }) => (
  <h2 className={styles.sectionTitle}>{children}</h2>
);

const SpecTable = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.specTable}>{children}</div>
);

const SpecRow = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.specRow}>{children}</div>
);

const SpecLabel = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.specLabel}>{children}</div>
);

const SpecValue = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.specValue}>{children}</div>
);

const TechContainer = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.techContainer}>{children}</div>
);

const TechSpecs = () => {
  return (
    <TechContainer>
      <Container>
        <Title>Technical Specifications</Title>

        <ProductImage>
          <Image src={'web_v2/uh-home/home-outline.svg'} alt={'uh-home'} fill />
        </ProductImage>

        <SpecificationSection>
          <SectionTitle>Dimensions & Weight </SectionTitle>
          <SpecTable>
            <SpecRow>
              <SpecLabel>Width</SpecLabel>
              <SpecValue>12 cm</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Height</SpecLabel>
              <SpecValue>4.7 cm</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Length</SpecLabel>
              <SpecValue>12 cm</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Weight</SpecLabel>
              <SpecValue>540 grams</SpecValue>
            </SpecRow>
          </SpecTable>
        </SpecificationSection>

        <SpecificationSection>
          <SectionTitle>Materials & Finish</SectionTitle>
          <SpecTable>
            <SpecRow>
              <SpecLabel>Enclosure</SpecLabel>
              <SpecValue>Anodised Aluminium</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Finish Options</SpecLabel>
              <SpecValue>Matte Finish</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Air Intake Grilles</SpecLabel>
              <SpecValue>Precision-perforated metal</SpecValue>
            </SpecRow>
          </SpecTable>
        </SpecificationSection>
        <SpecificationSection>
          <SectionTitle>Sensors & Inputs</SectionTitle>
          <SpecTable>
            <SpecRow>
              <SpecLabel>Air Quality</SpecLabel>
              <SpecValue>VOC, CO, CO₂, HCHO, Smoke</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Particulate matter</SpecLabel>
              <SpecValue> PM1.0, PM2.5, PM10</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Environment</SpecLabel>
              <SpecValue>Temperature, Humidity</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Light Exposure</SpecLabel>
              <SpecValue>Red, Blue, Green, Infrared Light</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>UV Exposure</SpecLabel>
              <SpecValue>UVA, UVB, UVC</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Sound</SpecLabel>
              <SpecValue>dBA-level microphone</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Ambient Noise</SpecLabel>
              <SpecValue>Noise Module (DB Level)</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Motion</SpecLabel>
              <SpecValue>
                Presence detection via PIR (optional inclusion)
              </SpecValue>
            </SpecRow>
          </SpecTable>
        </SpecificationSection>
        <SpecificationSection>
          <SectionTitle>Connectivity</SectionTitle>
          <SpecTable>
            <SpecRow>
              <SpecLabel>Wi-Fi</SpecLabel>
              <SpecValue>2.4GHz / 5GHz Dual-band</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Bluetooth</SpecLabel>
              <SpecValue>BLE 5.3</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>App Control</SpecLabel>
              <SpecValue>Via Ultrahuman app (iOS & Android)</SpecValue>
            </SpecRow>
          </SpecTable>
        </SpecificationSection>
        <SpecificationSection>
          <SectionTitle>Power</SectionTitle>
          <SpecTable>
            <SpecRow>
              <SpecLabel>Input Voltage</SpecLabel>
              <SpecValue>100-240V AC</SpecValue>
            </SpecRow>
            <SpecRow>
              <SpecLabel>Cable Length</SpecLabel>
              <SpecValue>1 meter</SpecValue>
            </SpecRow>
          </SpecTable>
        </SpecificationSection>
      </Container>
    </TechContainer>
  );
};

export default TechSpecs;
